import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { filter } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
    NewVersionConfirmationDialog,
} from '../../shared/components/new-version-confirmation-dialog/new-version-confirmation-dialog';

@Injectable({ providedIn: 'root' })
export class PromptUpdateService {
    constructor(swUpdate: SwUpdate, private ngbModal: NgbModal, public http: HttpClient) {
        swUpdate.versionUpdates
            .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe((evt) => {
                this.http.get<{ version: string }>('/version.json').subscribe(data => {
                    ngbModal.open(NewVersionConfirmationDialog, {
                        size: 'md',
                        windowClass: 'custom-modal',
                        backdrop: 'static',
                        keyboard: false,
                    }).componentInstance.args = {
                        version: data.version,
                        confirm: () => {
                            location.replace(location.origin);
                        }
                    }
                });
            });
    }
}
